import { Accordion } from '@apollo/orbit';
// eslint-disable-next-line no-restricted-imports
import { ExpandedIndex } from '@chakra-ui/react';
import classnames from 'classnames';
import React, { useCallback } from 'react';

import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';

/**
 * Renders the list of error groups.
 *
 * @param children Expecting a list of ErrorGroups.
 * @returns {JSX.Element} A rendered view of the groups.
 */
export function ErrorsByGroup({
  loading,
  expandedIndices,
  onExpandChange,
  children,
}: {
  loading?: boolean;
  expandedIndices: number[];
  onExpandChange: (expandedItems: number[]) => void;
  children: React.ReactNode;
}) {
  const trackCustomEvent = useTrackCustomEvent();
  const handleChange = useCallback(
    (expandedItems: ExpandedIndex) => {
      if (Array.isArray(expandedItems)) {
        onExpandChange(expandedItems);
      }
      trackCustomEvent({
        category: 'Operation Insights Errors',
        action: 'error_group_accordion_change',
      });
    },
    [onExpandChange, trackCustomEvent],
  );

  return (
    <Accordion
      className={classnames({ 'opacity-40': loading })}
      index={expandedIndices}
      allowMultiple
      onChange={handleChange}
    >
      {children}
    </Accordion>
  );
}
